import { gql } from '@apollo/client';

const ACADEMIC_SESSION_FRAGMENT = gql`
  fragment BaseAcademicSession on AcademicSession {
    id
    name
    organizationId
    dateTermStart
    dateTermEnd
    sourceKindId
    sourceKind
  }
`;

export default ACADEMIC_SESSION_FRAGMENT;
